import React from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import BotAvatar from './bot-avatar/BotAvatar';
import StepContent, { StepContentBody } from './step-content/StepContent';

import commonStyles from './../components/components.module.scss';

// Constants for selectors
export const CAMPAIGNS_SELECTOR = '.Campaigns';
export const CAMPAIGNS_SETTING_SELECTOR = '.Campaigns_Setting';
export const ADD_NEW_CAMPAIGN_SELECTOR = '[data-tour="add-new-campaign"]';
export const MODAL_BODY_SELECTOR = '.modal-body';
export const CAMPAIGN_SECOND_MODAL_BODY_SELECTOR = '.second-modal-body';
export const CAMPAIGN_SETTINGS_ICON = '[data-tour="campaign_settings_tour"]';
export const SITES_CONFIG_SELECTOR = '[data-tour="Sites_Config-tab"]';
export const SELECT_DROPDOWN_SELECTOR = '.selectOptions';
export const ADD_NEW_SITE_SELECTOR = '[data-tour="add-new-site"]';
export const SHORTCUTS_SELECTOR = '[data-tour="Shortcuts-tab"]';
export const DISPOSITION_SELECTOR = '[data-tour="Disposition-tab"]';
export const ADD_NEW_DISPOSITION_SELECTOR = '[data-tour="add-new-disposition"]';
export const ADD_NEW_SHORTCUT_SELECTOR = '[data-tour="add-new-shortcut"]';
export const FLECX_MODAL_SELECTOR = '.data-tour__flecx-modal';
export const ADMIN_SELECTOR = '.Users';
export const ADD_NEW_USER_SELECTOR = '[data-tour="add-new-user"]';
export const AGENT_REQUESTS_SELECTOR = '[data-tour="agent-requests-panel"]';
export const AGENT_AVATAR_SELECTOR = '[data-tour="agent-avatar"]';
export const CHATS_LIST_SELECTOR = '[data-tour="chats-list"]';
export const CHAT_CONTAINER_SELECTOR = '[data-tour="chat-container"]';
export const ONLINE_AGENTS_PANEL_SELECTOR = '[data-tour="online-agents-panel"]';
export const AVAILABILITY_SELECT_SELECTOR = '.availablity-select';
export const SITE_SCRIPT_ICON_SELECTOR = '.site_script_icon';
export const SITE_SCRIPT_TOOLTIP_SELECTOR = '.site_script_tooltip';
export const FLECX_LOGO_SELECTOR = '[data-tour="flecx-logo"]';
export const FLECX_LOGO_LARGE_SELECTOR = '[data-tour="flecx-logo-lg"]';
export const SHARE_TRANSCRIPT_SELECTOR = '[data-tour="share-transcript"]';
export const MARK_DISPOSITION_SELECTOR = '[data-tour="mark-disposition"]';
export const FLECX_MODAL_CLOSE_SELECTOR = '.close';
export const FLECX_MENU_SELECTOR = '.flecx__menu';
export const CUSTOMER_PROFILE_PANEL_SELECTOR =
  '[data-tour="customer-profile-panel"]';
export const TRANSCRIPT_DETAILS_PANEL_SELECTOR =
  '[data-tour="transcript-detail-panel"]';
export const AGENT_TO_AGENT_CONVERSATIONS_SELECTOR =
  'ul.chat__tabs li:nth-child(2) > span';
export const ACTIVE_CONVERSATIONS_TAB_SELECTOR =
  'ul.chat__tabs li:nth-child(1) > span';
export const CLOSE_CONVERSATIONS_TAB_SELECTOR =
  'ul.chat__tabs li:nth-child(3) > span';

// other constatns
export const TRANSITION_TIMEOUT = 250;
export const TOUR_DEFAULT_STYLE = {
  popover: (base) => ({
    ...base,
    '--reactour-accent': 'darkgrey',
    borderRadius: 6,
  }),
  maskArea: (base) => ({ ...base, rx: 10 }),
  maskWrapper: (base) => ({ ...base }),
  badge: (base) => ({ ...base, left: 'auto', right: '-0.8125em' }),
  controls: (base) => ({ ...base, marginTop: '0.625rem' }),
  close: (base) => ({
    ...base,
    display: 'inline-flex',
    right: 15,
    top: 15,
  }),
};

// Disable body scroll
export const disableBody = (target) => disableBodyScroll(target);
// Enable body scroll
export const enableBody = (target) => enableBodyScroll(target);
/**
 *
 * @param {string} selector       Selector for element.
 * @param {function} callback     Function to run when element got.
 * @param {integer} timeout       Timeout for interval.
 * @returns
 */
export const getElementInternal = (
  selector,
  callback,
  timeout = TRANSITION_TIMEOUT * 4
) => {
  console.log('=======Start getElementInternal=======');
  console.log(
    '>>>>>>>>>>>>> selector',
    selector,
    'callback',
    callback,
    'timeout',
    timeout
  );

  // If selector is not given run callback with default timeout.
  // then return
  if (!selector) {
    setTimeout(() => {
      callback();
    }, TRANSITION_TIMEOUT);

    return;
  }

  // Interval for given element then run callback.
  const elementInterval = setInterval(() => {
    const element = document.querySelector(selector);
    console.log('>>>>>>>>>>>>> element ', selector, element);
    if (element) {
      setTimeout(() => {
        callback();
      }, TRANSITION_TIMEOUT);

      clearInterval(elementInterval);
    }
  }, timeout);
  console.log('=======End getElementInternal=======');
};

// Agent role steps
export const MainStepsAgent = (actions = []) => [
  {
    index: 0,
    selector: AGENT_REQUESTS_SELECTOR,
    resizeObservables: [AGENT_REQUESTS_SELECTOR],
    content: () => (
      <StepContent
        titleImageSrc={'/images/agent-tour/01-request.png'}
        titleImageAlt={'Customer chat request'}
        title='Chat Request'
        content='Whenever a customer sends you a chat request you can see those
    requests in this section as well as accept them by pressing
    accept button.'
      />
    ),
    position: ({ left, top }) => [left - 300, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '280px',
      }),
    },
    action: function () {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 1,
    selector: CHATS_LIST_SELECTOR,
    resizeObservables: [CHATS_LIST_SELECTOR],
    content: () => (
      <StepContent
        titleImageSrc={'/images/agent-tour/02-active-conversations-list.png'}
        titleImageAlt={'Active Conversations'}
        title='Active Conversations'
        content='After accepting a chat request it will start showing in the
        active tab section. You can see all your ongoing conversations
        here.'
      />
    ),
    position: ({ left, top }) => [left + 375, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // Open agent profile modal and send it to back
      const agentAvatar = document.querySelector(AGENT_AVATAR_SELECTOR);
      if (agentAvatar) agentAvatar.click();
      setTimeout(() => {
        const flecxModal = document.querySelector(FLECX_MODAL_SELECTOR);
        if (flecxModal) flecxModal.parentElement.style.zIndex = -1;
      }, TRANSITION_TIMEOUT);

      // Activate active conversations tab
      const activeConvTab = elem.querySelector(
        ACTIVE_CONVERSATIONS_TAB_SELECTOR
      );
      if (activeConvTab) activeConvTab.click();

      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 2,
    selector: CHAT_CONTAINER_SELECTOR,
    resizeObservables: [CHAT_CONTAINER_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/03-active-conversation.png'}
        titleImageAlt={'Selected Conversation'}
        title='Selected Conversation'
        content='A selected conversation will show in the center panel. Here you
        can chat with the customer, see the whole conversation, transfer
        it and also mark the disposition.'
      />
    ),
    position: ({ left, right, top }) => [right - left - 585, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '400px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 3,
    selector: CUSTOMER_PROFILE_PANEL_SELECTOR,
    resizeObservables: [CUSTOMER_PROFILE_PANEL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/04-customer-profile.png'}
        titleImageAlt={'Customer Profile'}
        title='Customer Profile'
        content='You can see customer profile here for selected conversation.'
      />
    ),
    position: ({ left, top }) => [left - 300, top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '280px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 4,
    selector: TRANSCRIPT_DETAILS_PANEL_SELECTOR,
    resizeObservables: [TRANSCRIPT_DETAILS_PANEL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/05-transcript-details.png'}
        titleImageAlt={'Transcript Details'}
        title='Transcript Details'
        content='Information for the selected chat is shown in this section.'
      />
    ),
    position: ({ left, top }) => [left - 300, top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '280px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 5,
    selector: SHARE_TRANSCRIPT_SELECTOR,
    resizeObservables: [SHARE_TRANSCRIPT_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/06-share-transcript.png'}
        titleImageAlt={'Share Transcript'}
        title='Share Transcript'
        content='The transcript for the selected chat can be shared by clicking
        share icon on the chat header.'
      />
    ),
    position: ({ left, top }) => [left - 375, top + 20],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 6,
    selector: SHARE_TRANSCRIPT_SELECTOR,
    resizeObservables: [SHARE_TRANSCRIPT_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/07-share-transcript-modal.png'}
        titleImageAlt={'Share Transcript'}
        title='Share Transcript'
        content='Clicking the Share icon will allow you to enter the email
        address to share transcript with.'
      />
    ),
    position: 'center',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '400px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 7,
    selector: MARK_DISPOSITION_SELECTOR,
    resizeObservables: [MARK_DISPOSITION_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/08-mark-disposition.png'}
        titleImageAlt={'Mark Disposition'}
        title='Mark Disposition'
        content='To select disposition options for selected chat click the Mark
        disposition icon.'
      />
    ),
    position: ({ left, top }) => [left - 370, top + 20],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 8,
    selector: MARK_DISPOSITION_SELECTOR,
    resizeObservables: [MARK_DISPOSITION_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/09-mark-disposition-modal.png'}
        titleImageAlt={'Mark Disposition'}
        title='Mark Disposition'
        content='Select and save the disposition with notes from the opened
        modal. This will Close the chat.'
      />
    ),
    // position: (postionsProps) => [postionsProps.left * 1.1, 30],
    position: 'center',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '400px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 9,
    selector: CHATS_LIST_SELECTOR,
    resizeObservables: [CHATS_LIST_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/10-close-conversations.png'}
        titleImageAlt={'Closed Conversations'}
        title='Closed Conversations'
        content='You can find all closed conversations here and select any
        conversation to see further details related to it.'
      />
    ),
    position: ({ left, top }) => [left + 375, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '400px',
      }),
    },
    action: function (elem) {
      const closesConvTab = elem.querySelector(
        CLOSE_CONVERSATIONS_TAB_SELECTOR
      );
      if (closesConvTab) closesConvTab.click();
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 10,
    selector: CHATS_LIST_SELECTOR,
    resizeObservables: [CHATS_LIST_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={
          '/images/agent-tour/11-eye-button-transcript-details-modal.png'
        }
        titleImageAlt={'Transcript Detail Modal'}
        title='Transcript Details'
        content='You can see the transcript details directly by pressing eye icon
        against the conversation.'
      />
    ),
    position: ({ left, top }) => [left + 375, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 11,
    selector: ONLINE_AGENTS_PANEL_SELECTOR,
    resizeObservables: [ONLINE_AGENTS_PANEL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/12-online-agents.png'}
        titleImageAlt={'Online Agents'}
        title='Online Agents'
        content='Here you can see other online agents.'
      />
    ),
    position: ({ left, top }) => [left - 320, top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 12,
    selector: ONLINE_AGENTS_PANEL_SELECTOR,
    resizeObservables: [ONLINE_AGENTS_PANEL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/13-transfer-chat-to-agent.png'}
        titleImageAlt={'Transfer Chat'}
        title='Transfer Chat'
        content='If you want to transfer the selected conversation to your
        colleague, you can simply transfer the selected conversation to
        another online agent by pressing the transfer chat button.'
      />
    ),
    position: ({ left, top }) => [left - 320, top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 13,
    selector: ONLINE_AGENTS_PANEL_SELECTOR,
    resizeObservables: [ONLINE_AGENTS_PANEL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContent
        titleImageSrc={'/images/agent-tour/14-chat-online-agent.png'}
        titleImageAlt={'Online Agents'}
        title='Chat With Online Agents'
        content='You can start a conversation with another online agent as well
        by pressing the chat icon.'
      />
    ),
    position: ({ left, top }) => [left - 320, top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 14,
    selector: CHATS_LIST_SELECTOR,
    resizeObservables: [CHATS_LIST_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContentBody
        title='Conversations With Agents'
        content='You can find all agent-to-agent conversations here.'
      />
    ),
    position: ({ left, top }) => [left + 375, top + 30],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      const agent2agentConvTab = elem.querySelector(
        AGENT_TO_AGENT_CONVERSATIONS_SELECTOR
      );
      if (agent2agentConvTab) agent2agentConvTab.click();
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 15,
    selector: AGENT_AVATAR_SELECTOR,
    resizeObservables: [AGENT_AVATAR_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContentBody
        title='My Profile Image'
        content='Clicking this avatar will show my saved image which is also shown to
        the customer.'
        contentJustify
      />
    ),
    position: ({ left, top }) => [left + 50, top + 20],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      maskArea: (base) => ({ ...base, rx: 25 }),
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 16,
    selector: FLECX_MODAL_SELECTOR,
    // resizeObservables: [FLECX_MODAL_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContentBody
        title='My Profile'
        content='Here you can find your profile details.'
        contentJustify
      />
    ),
    position: 'right',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      maskArea: (base) => ({ ...base, rx: 10 }),
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      elem.parentElement.style.zIndex = 99;
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
    actionAfter: (elem) => {
      elem.parentElement.style.zIndex = -1;
    },
  },
  {
    index: 17,
    selector: AVAILABILITY_SELECT_SELECTOR,
    resizeObservables: [AVAILABILITY_SELECT_SELECTOR],
    content: ({ setCurrentStep }) => (
      <StepContentBody
        title='Availablity Status'
        content='You can choose your current availability status from here.'
      />
    ),
    position: 'right',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        borderRadius: 6,
        maxWidth: '300px',
      }),
    },
    action: function (elem) {
      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
  {
    index: 18,
    selector: FLECX_LOGO_SELECTOR,
    resizeObservables: [FLECX_LOGO_SELECTOR],
    content: ({ setIsOpen }) => (
      <div>
        <BotAvatar />
        <p className='textSize16'>Congratulations. You did it!</p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='OK'
            style={{ display: 'block' }}
            onClick={() => setIsOpen(false)}
          />
        </div>
      </div>
    ),
    position: 'center',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      maskArea: (base) => ({ ...base, rx: 50 }),
    },
    action: function (elem) {
      // bring up agent profile modal and close it.
      const flecxModal = document.querySelector(FLECX_MODAL_SELECTOR);
      if (flecxModal) {
        flecxModal.parentElement.style.zIndex = 99;
        const closeBtn = flecxModal.querySelector(FLECX_MODAL_CLOSE_SELECTOR);
        if (closeBtn) closeBtn.click();
      }

      // Activate active conversations tab
      const activeConvTab = document.querySelector(
        ACTIVE_CONVERSATIONS_TAB_SELECTOR
      );
      if (activeConvTab) activeConvTab.click();

      // actions set when initial from outside
      const callback = actions.find((action) => action.step === this.index);
      if (callback) callback.action();
    },
  },
];

// Supervisor role steps
export const MainStepsSupervisor = [
  {
    selector: CAMPAIGNS_SELECTOR,
    content: (
      <div>
        <p className='m-0'>Click campaign to add a new campaign.</p>
      </div>
    ),
    resizeObservables: [CAMPAIGNS_SELECTOR],
  },
];

export const AddingCampaignSteps = [
  {
    index: 0,
    selector: ADD_NEW_CAMPAIGN_SELECTOR,
    highlightedSelectors: [ADD_NEW_CAMPAIGN_SELECTOR],
    mutationObservables: [ADD_NEW_CAMPAIGN_SELECTOR],
    resizeObservables: [ADD_NEW_CAMPAIGN_SELECTOR],
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Click <strong className='textSize14 pinkText'>Add New</strong> button
          for creating a new campaign.
        </p>
        <div>
          <p>
            But if you don't want to create a new campaign, you can skip this
            step by pressing{' '}
            <strong className='textSize14 pinkText'>Skip</strong> button.
          </p>
          <div className='d-flex justify-content-center align-items-center'>
            <input
              type='button'
              className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
              value='Skip'
              style={{ display: 'block' }}
              onClick={() => setCurrentStep(3)}
              data-tour=''
            />
          </div>
        </div>
      </div>
    ),
    position: (postionsProps) => [postionsProps.left - 420, postionsProps.top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      maskArea: (base) => ({ ...base, rx: 20 }),
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '400px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 1,
    selector: MODAL_BODY_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Add your campaign details and click{' '}
          <strong className='textSize14 pinkText'>Next</strong> button.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(2)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'left',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '160px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 2,
    selector: CAMPAIGN_SECOND_MODAL_BODY_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Add your campaign details and click{' '}
          <strong className='textSize14 pinkText'>Add</strong> button.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(2)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'left',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '160px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 3,
    selector: CAMPAIGN_SETTINGS_ICON,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Your new campaign has been added successfully. Click on{' '}
          <strong className='pinkText'>Settings</strong>.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(3)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    resizeObservables: [CAMPAIGN_SETTINGS_ICON],
    // actionAfter: (elem) => {
    //   if (!elem.className.includes('activeLink')) {
    //     elem.click();
    //   }
    // },
  },
];

export const AddingCampaignSettingsSteps = [
  // {
  //   index: 2,
  //   selector: SITES_CONFIG_SELECTOR,
  //   mutationObservables: [SITES_CONFIG_SELECTOR],
  //   content: ({ setCurrentStep }) => (
  //     <div>
  //       <span>
  //         Your new campaign has been added successfully. Click on{' '}
  //         <strong className='pinkText'>Sites Config</strong> to add websites.
  //       </span>
  //       <div className='d-flex justify-content-center align-items-center'>
  //         <input
  //           type='button'
  //           className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
  //           value='Skip'
  //           style={{ display: 'block' }}
  //           onClick={() => setCurrentStep(3)}
  //           data-tour=''
  //         />
  //       </div>
  //     </div>
  //   ),
  //   actionAfter: (elem) => {
  //     if (!elem.className.includes('activeLink')) {
  //       elem.click();
  //     }
  //   },
  // },
  {
    index: 0,
    selector: SELECT_DROPDOWN_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <p>Your selected campaign will show here.</p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Next'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(1)}
            data-tour=''
          />
        </div>
      </div>
    ),
    highlightedSelectors: [SELECT_DROPDOWN_SELECTOR, FLECX_MENU_SELECTOR],
    resizeObservables: [FLECX_MENU_SELECTOR],
    position: 'right',
  },
  {
    index: 1,
    selector: ADD_NEW_SITE_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Click <strong className='textSize14 pinkText'>Add New</strong> button
          to add new website to the campaign.
        </p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(3)}
            data-tour=''
          />
        </div>
      </div>
    ),
  },
  {
    index: 2,
    selector: MODAL_BODY_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Add your site details and click{' '}
          <strong className='textSize14 pinkText'>Add</strong> button.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(6)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'left',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '300px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 3,
    selector: SHORTCUTS_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Click on <strong className='textSize14 pinkText'>Shortcuts</strong>{' '}
          tab.
        </span>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(6)}
            data-tour=''
          />
        </div>
      </div>
    ),
    // actionAfter: (elem) => {
    //   if (!elem.className.includes('activeLink')) {
    //     elem.click();
    //   }
    // },
  },
  {
    index: 4,
    selector: ADD_NEW_SHORTCUT_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Click <strong className='textSize14 pinkText'>Add New</strong> button
          to add shortcuts to the campaign.
        </p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(9)}
            data-tour=''
          />
        </div>
      </div>
    ),
  },
  {
    index: 5,
    selector: FLECX_MODAL_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Add your shortcut details and click{' '}
          <strong className='textSize14 pinkText'>Add</strong> button.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(9)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'top',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '500px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 6,
    selector: DISPOSITION_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Click on <strong className='textSize14 pinkText'>Disposition</strong>{' '}
          tab.
        </span>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(9)}
            data-tour=''
          />
        </div>
      </div>
    ),
    // actionAfter: (elem) => {
    //   if (!elem.className.includes('activeLink')) {
    //     elem.click();
    //   }
    // },
  },
  {
    index: 7,
    selector: ADD_NEW_DISPOSITION_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Click <strong className='textSize14 pinkText'>Add New</strong> button
          to add disposition to the campaign.
        </p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(9)}
            data-tour=''
          />
        </div>
      </div>
    ),
  },
  {
    index: 8,
    selector: FLECX_MODAL_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <span>
          Add your disposition details and click{' '}
          <strong className='textSize14 pinkText'>Add</strong> button.
        </span>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(9)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'top',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '500px',
        borderRadius: 10,
      }),
    },
  },
  {
    index: 9,
    selector: ADMIN_SELECTOR,
    content: `Let's move to Users page. So, we can create new users.`,
    resizeObservables: [ADMIN_SELECTOR],
  },
  {
    index: 10,
    selector: SITE_SCRIPT_TOOLTIP_SELECTOR,
    highlightedSelectors: [
      SITE_SCRIPT_ICON_SELECTOR,
      SITE_SCRIPT_TOOLTIP_SELECTOR,
    ],
    resizeObservables: [
      SITE_SCRIPT_ICON_SELECTOR,
      SITE_SCRIPT_TOOLTIP_SELECTOR,
    ],
    mutationObservables: [
      SITE_SCRIPT_ICON_SELECTOR,
      SITE_SCRIPT_TOOLTIP_SELECTOR,
    ],
    content: `Click on copy icon to copy the script. Integrate this script in the added website to activate the customer chat widget.`,
  },
];

export const CreateUserSteps = (actions) => [
  {
    index: 0,
    selector: ADD_NEW_USER_SELECTOR,
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Click <strong className='textSize14 pinkText'>Add New</strong> button
          to create a new user.
        </p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(2)}
            data-tour=''
          />
        </div>
      </div>
    ),
    position: (postionsProps) => [postionsProps.left - 275, postionsProps.top],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '250px',
        borderRadius: 10,
      }),
    },
    action: () => {
      const callback = actions.find((action) => action.step === 0);
      if (callback) callback.action();
    },
  },
  {
    index: 1,
    selector: MODAL_BODY_SELECTOR,
    resizeObservables: [MODAL_BODY_SELECTOR],
    content: ({ setCurrentStep }) => (
      <div>
        <p>
          Add user's required information and click{' '}
          <strong className='textSize14 pinkText'>Add</strong> button.
        </p>
        {/* <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='Skip'
            style={{ display: 'block' }}
            onClick={() => setCurrentStep(0)}
            data-tour=''
          />
        </div> */}
      </div>
    ),
    position: 'right',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({
        ...base,
        '--reactour-accent': 'darkgrey',
        maxWidth: '300px',
        borderRadius: 10,
      }),
    },
    action: () => {
      const callback = actions.find((action) => action.step === 1);
      if (callback) callback.action();
    },
  },
  {
    index: 2,
    content: ({ setIsOpen }) => (
      <div>
        <p>Congratulations. You did it!</p>
        <div className='d-flex justify-content-center align-items-center'>
          <input
            type='button'
            className={`pinkText ${commonStyles['fl-btn']} ${commonStyles.outlined} ${commonStyles.rounded} ${commonStyles.shadow}`}
            value='OK'
            style={{ display: 'block' }}
            onClick={() => setIsOpen(false)}
          />
        </div>
      </div>
    ),
    position: 'center',
    styles: {
      ...TOUR_DEFAULT_STYLE,
      maskArea: (base) => ({ ...base, width: 0, height: 0 }),
    },
    action: () => {
      const callback = actions.find((action) => action.step === 2);
      if (callback) callback.action();
    },
  },
];

export const EmptyStep = [
  {
    index: 0,
    content: '',
    position: [0, 0],
    styles: {
      ...TOUR_DEFAULT_STYLE,
      popover: (base) => ({ ...base, padding: 0 }),
      close: (base) => ({}),
      maskArea: (base) => ({ ...base, width: 0, height: 0 }),
    },
  },
];
